// NOTE: NSAI-6994 — the navigation state an explicit "New chat" sends (the
// sidebar button, the dashboards breadcrumb's home link, the search palette's
// "New chat"). An unsent new-chat composer is kept per scope (NSAI-3912), and
// plain /chat is one scope, so without this marker "New chat" handed back
// whatever was left in it — the attached file came back while the models
// picked beside it were re-resolved to the default. The chat page reads it,
// discards that scope's unsent composer and strips it again.
export const FRESH_CHAT_LOCATION_STATE = { isFreshChat: true } as const;
